import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { BlogSeo } from "../../../../services/blogService";

interface BlogSeoPanelProps {
	seo: BlogSeo;
	onChange: (nextSeo: BlogSeo) => void;
}

const BlogSeoPanel = ({ seo, onChange }: BlogSeoPanelProps) => {
	const updateField = (
		field: keyof BlogSeo,
		value: string | boolean,
	) => {
		onChange({
			...seo,
			[field]: value as never,
		});
	};

	return (
		<Card className="border-0 shadow-sm mb-3">
			<Card.Header className="fw-semibold">SEO</Card.Header>
			<Card.Body>
				<Form.Group className="mb-3" controlId="blogSeoTitle">
					<Form.Label>SEO Title</Form.Label>
					<Form.Control
						value={seo.metaTitle}
						onChange={(event) => updateField("metaTitle", event.target.value)}
						maxLength={60}
					/>
					<Form.Text>{seo.metaTitle.length}/60</Form.Text>
				</Form.Group>

				<Form.Group className="mb-3" controlId="blogSeoDescription">
					<Form.Label>Meta Description</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						value={seo.metaDescription}
						onChange={(event) =>
							updateField("metaDescription", event.target.value)
						}
						maxLength={160}
					/>
					<Form.Text>{seo.metaDescription.length}/160</Form.Text>
				</Form.Group>

				<Form.Group className="mb-3" controlId="blogSeoCanonicalUrl">
					<Form.Label>Canonical URL</Form.Label>
					<Form.Control
						value={seo.canonicalUrl}
						onChange={(event) =>
							updateField("canonicalUrl", event.target.value)
						}
						placeholder="https://www.theracecompanion.com/..."
					/>
				</Form.Group>

				<Form.Group className="mb-3" controlId="blogSeoOgImageUrl">
					<Form.Label>Open Graph Image URL</Form.Label>
					<Form.Control
						value={seo.ogImageUrl}
						onChange={(event) => updateField("ogImageUrl", event.target.value)}
						placeholder="https://..."
					/>
				</Form.Group>

				<Row className="g-3">
					<Col md={6}>
						<Form.Check
							type="switch"
							id="blogSeoRobotsIndex"
							label="Robots: index"
							checked={seo.robotsIndex}
							onChange={(event) =>
								updateField("robotsIndex", event.target.checked)
							}
						/>
					</Col>
					<Col md={6}>
						<Form.Check
							type="switch"
							id="blogSeoRobotsFollow"
							label="Robots: follow"
							checked={seo.robotsFollow}
							onChange={(event) =>
								updateField("robotsFollow", event.target.checked)
							}
						/>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
};

export default BlogSeoPanel;
